import axios from 'axios';

const TOKEN_KEY = 'zephir_access';
const REFRESH_KEY = 'zephir_refresh';
const BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getRefresh = () => localStorage.getItem(REFRESH_KEY);
export const setTokens = (access, refresh) => { localStorage.setItem(TOKEN_KEY, access); localStorage.setItem(REFRESH_KEY, refresh); };
export const clearTokens = () => { localStorage.removeItem(TOKEN_KEY); localStorage.removeItem(REFRESH_KEY); };
export const isAuthenticated = () => !!getToken();

export const logout = async () => {
  const refresh = getRefresh();
  const access = getToken();
  if (refresh && access) {
    try {
      await axios.post(BASE + '/auth/logout/', { refresh }, {
        headers: { Authorization: 'Bearer ' + access }
      });
    } catch {}
  }
  clearTokens();
  window.location.href = '/login';
};
